/* eslint-disable import/prefer-default-export */

export function studlyCase(string) {
  return string.split('-').map(word => `${word.charAt(0).toUpperCase()}${word.slice(1)}`);
}

export function camelCase(string) {
  return `${string.charAt(0).toLowerCase()}${studlyCase(string).slice(1)}`;
}
